import { motion, useScroll, useSpring } from "framer-motion";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Manifesto } from "@/components/Manifesto";
import { Work } from "@/components/Work";
import { Testimonials } from "@/components/Testimonials";
import { PlatformProof } from "@/components/PlatformProof";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function HomePage() {
  usePageMeta(
    "Build Right Partners — Marketing Agency in California",
    "Branding, Google Ads, Meta & Yelp Ads, SEO, web development, and weekly on-site commercial filming for California businesses. Right Partner. Right Path. Right Growth."
  );
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 90, damping: 25 });

  return (
    <main data-testid="home-page" className="bg-[#060B18] text-slate-100">
      <motion.div
        style={{ scaleX }}
        className="fixed top-0 left-0 right-0 h-[2px] origin-left z-[70] bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA7C11]"
      />
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Manifesto />
      <Work />
      <Testimonials />
      <PlatformProof />
      <Contact />
      <Footer />
    </main>
  );
}
